import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				background: theme.palette.common.white
			},
			headerRegister: {
				textAlign: "center",
				padding: "30px 0px"
			},
			titleHeader: {
				fontSize: 20,
				fontWeight: 500,
				color: theme.palette.primary.contrastText
			},
			subTitleHeader: {
				fontSize: 14,
				marginTop: 5,
				color: theme.palette.grey[700]
			},
			rootForm: {
				padding: 20
			},
			btnBack: {
				width: "fit-content",
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			title: {
				fontSize: 16,
				fontWeight: 500,
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				"& > img": {
					marginRight: 5
				},
				"& >span": {
					color: theme.palette.error.main,
					marginLeft: 3
				}
			},
			borderTitle: {
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				paddingBottom: 50,
				marginBottom: 10
			},
			customInput: {
				color: theme.palette.primary.contrastText,
				marginTop: 5,
				marginBottom: 15,
				"& > .MuiInput-root": {
					height: "inherit",
					border: "1px solid #c4c4c3",
					borderRadius: 6
				},
				height: "100%",
				width: "100%",
				"& > div > input": {
					color: theme.palette.primary.contrastText,
					height: 37,
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 18,
					lineHeight: "21px",
					padding: "3px 10px",
					"@media only screen and (max-width: 768px)": {
						fontSize: 16,
						lineHeight: "19px"
					}
				},
				"& > div > textarea": {
					color: theme.palette.primary.contrastText,
					margin: 20,
					backgroundColor: theme.palette.grey["A100"]
				},
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.primary.contrastText,
					textAlign: "initial",
					marginLeft: 15
				}
			},
			inputError: {
				border: `1px solid ${theme.palette.error.main} !important`,
				borderRadius: "6px !important"
			},
			bodyBtnSubmit: {
				padding: "30px 30px 10px",
				textAlign: "center"
			},
			btnSubmit: {
				background: theme.palette.error.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "capitalize",
				width: 167,
				height: 36,
				borderRadius: 6,
				"&:hover": {
					background: `${theme.palette.error.main} !important`
				}
			},
			textError: {
				fontSize: 12,
				marginBottom: 5,
				color: theme.palette.error.main
			}
		}),
	{
		name: "CreatePassword",
		index: 1
	}
);

export default useStyles;
